// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__2DBi2","headerContent":"header_headerContent__rFtPG","logoImg":"header_logoImg__1rb4V","btnLink":"header_btnLink__2fsaO"};